module.exports = __webpack_public_path__ + "img/4E5150_9FA3A3_848C8A_82848C-256px.771ab8cb.png";